module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', [_vm._l((_vm.groups), function(group) {
    return [_c('data-list', {
      key: ("group-" + (group.id)),
      staticClass: "pa-0",
      attrs: {
        "items": group.data,
        "title-path": "first_name",
        "sub-title-path": "profile.practice_name",
        "avatar-path": "profile.profile_picture",
        "avatar-position": "after"
      },
      on: {
        "selected": _vm.emitSelected
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function(props) {
          return [_vm._v("\n            " + _vm._s(props.item.first_name) + " " + _vm._s(props.item.last_name) + "\n        ")]
        }
      }, {
        key: "avatar-after",
        fn: function(props) {
          return [_c('v-list-tile-avatar', [(props.item.profile && props.item.profile.profile_picture) ? _c('img', {
            attrs: {
              "src": props.item.profile.profile_picture
            }
          }) : _c('v-icon', [_vm._v("account_circle")])], 1)]
        }
      }], null, true)
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-653b9cad","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/GroupedPractitionerPicker.vue
// module id = 1449
// module chunks = 9